// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  getDocs,
  doc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore"; // query and where should be imported from firestore

import { getStorage } from "firebase/storage"; // getStorage remains from firebase/storage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAnLqIuK8xcLgqJP5bUKPtvhMJInP0VgzQ",
  authDomain: "fixed-and-fitted.firebaseapp.com",
  projectId: "fixed-and-fitted",
  storageBucket: "fixed-and-fitted.firebasestorage.app",
  messagingSenderId: "899439166974",
  appId: "1:899439166974:web:cd49768f97378dc0222caf",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

// Export required functions
export {
  db,
  collection,
  addDoc,
  getDocs,
  doc,
  deleteDoc,
  query,
  where,
  storage,
};
